import React from 'react';
// const Footer = () => {
//   return (
//     <footer className="bg-gray-900 text-gray-300 p-6 mt-8 rounded-t-lg shadow-inner">
//       <div className="container mx-auto text-center">
//         <p className="text-sm mb-4">&copy; {new Date().getFullYear()} Yoga Studio. All rights reserved.</p>
//         <div className="flex justify-center space-x-6">
//           <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-blue-500 transition-colors duration-300">
//             <i className="fab fa-facebook-f text-xl"></i>
//           </a>
//           <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-blue-400 transition-colors duration-300">
//             <i className="fab fa-twitter text-xl"></i>
//           </a>
//           <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-pink-500 transition-colors duration-300">
//             <i className="fab fa-instagram text-xl"></i>
//           </a>
//           <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-blue-700 transition-colors duration-300">
//             <i className="fab fa-linkedin-in text-xl"></i>
//           </a>
//         </div>
//       </div>
//     </footer>
//   );
// };

// export default Footer;


const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300 p-6 mt-8 rounded-t-lg shadow-inner">
      <div className="container mx-auto text-center">
        <p className="text-sm mb-4">&copy; {new Date().getFullYear()} Yoga Studio. All rights reserved.</p>
        <div className="flex justify-center space-x-6">
          <a href="https://www.facebook.com/p/Yogavantha-100063645977255/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-blue-500 transition-colors duration-300">
            <i className="fab fa-facebook-f text-xl"></i>
          </a>
          <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-blue-400 transition-colors duration-300">
            <i className="fab fa-twitter text-xl"></i>
          </a>
          <a href="https://www.instagram.com/yogavantha_yogaclass/?hl=en" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-pink-500 transition-colors duration-300">
            <i className="fab fa-instagram text-xl"></i>
          </a>
          <a href="https://www.youtube.com/@yogavantha" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-red-600 transition-colors duration-300">
            <i className="fab fa-youtube text-xl"></i>
          </a>
        </div>
      </div>
      {/* Font Awesome for social media icons */}
      <script src="https://kit.fontawesome.com/a076d05399.js" crossOrigin="anonymous"></script>
    </footer>
  );
};

export default Footer;
